import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import { Ticket } from "../../types";
import {
  formatDate,
  formatRelativeDate,
  getStatusLabel,
  getStatusSince,
} from "../../utils";

interface TicketTimestampsProps {
  ticket: Ticket;
}

export default function TicketTimestamps({ ticket }: TicketTimestampsProps) {
  const statusSince = getStatusSince(ticket);
  return (
    <DSBox>
      <DSTypography variant="caption" sx={{ color: "text.secondary" }}>
        {ticket.key} &middot; Created {formatDate(ticket.createdAt)} &middot;
        Updated {formatRelativeDate(ticket.updatedAt)}
        {ticket.resolvedAt &&
          ` · Resolved ${formatRelativeDate(ticket.resolvedAt)}`}
        {statusSince &&
          ` · ${getStatusLabel(ticket.status)} since ${formatRelativeDate(statusSince)}`}
      </DSTypography>
    </DSBox>
  );
}
